<template>
  <div style="position: relative">
    <v-premium-plan-popup
      v-if="$store.getters.getPackage != 'premium'"
      :show-all="false"
      margin-top="65"
      style="border-radius: 5px"
    ></v-premium-plan-popup>
    <v-container>
      <div>
        <h3 class="headline">{{ $t('Cart Summary History') }}</h3>
        <v-layout row wrap>
          <v-flex class="mb-4" sm12 xs12>
            <div>
              <date-filter
                v-model="selectedDate"
                :default-filter="'today'"
                @changeDate="onDateChanged"
              ></date-filter>
            </div>

            <v-divider class="mt-3"></v-divider>
          </v-flex>
          <v-flex sm6 xs12>
            <div
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                :color="filterApp != 'all' ? 'grey' : 'primary'"
                :outline="filterApp != 'all'"
                class="ma-1"
                depressed
                small
                @click="filterApp = 'all'"
                >{{ $t('All') }} {{ `(${rawusers.length})` }}
              </v-btn>
              <v-btn
                :color="filterApp != 'facebook' ? 'grey' : 'primary'"
                :outline="filterApp != 'facebook'"
                class="ma-1"
                depressed
                small
                @click="filterApp = 'facebook'"
                >{{ $t('facebook') }} {{ `(${facebooklength})` }}
              </v-btn>
              <v-btn
                :color="filterApp != 'line' ? 'grey' : 'primary'"
                :outline="filterApp != 'line'"
                class="ma-1"
                depressed
                small
                @click="filterApp = 'line'"
                >{{ $t('line') }} {{ `(${linelength})` }}
              </v-btn>
            </div>
          </v-flex>
          <v-flex class="text-xs-right" sm6 xs12>
            <v-btn class="ma-0 mb-1" color="grey" outline @click="exportCartSummary">
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
            </v-btn>
            <v-btn class="ma-0 mb-1 ml-2" color="primary" icon outline @click="getUser">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-flex>
          <v-flex sm12 xs12>
            <div>
              <div
                v-if="isCentralLive"
                class="nav nav-tabs"
                style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
              >
                <v-btn
                  :color="filterCategoryStatus != 'all' ? 'grey' : 'primary'"
                  :outline="filterCategoryStatus != 'all'"
                  class="ma-1"
                  depressed
                  small
                  @click="filterCategoryStatus = 'all'"
                  >{{ $t('All') }}
                </v-btn>
                <v-btn
                  v-for="(category, k) in categories"
                  :key="k"
                  :color="filterCategoryStatus != category ? 'grey' : 'primary'"
                  :outline="filterCategoryStatus != category"
                  class="ma-1"
                  depressed
                  small
                  @click="filterCategoryStatus = category"
                  >{{ category }}
                </v-btn>
              </div>
            </div>
          </v-flex>
          <v-flex class="text-xs-left" xs12>
            <v-layout>
              <v-flex
                v-if="
                  ['109154847972476', '109181747969457', '178737485661189'].includes(
                    selectedBot.pageid
                  )
                "
                class="pr-2"
                xs6
              >
                <Multiselect
                  v-model="filter.page"
                  :allow-empty="false"
                  :options="pageOptions"
                  :show-labels="false"
                  label="text"
                  placeholder="เลือกเพจ"
                  track-by="value"
                  @input="onFilter"
                ></Multiselect>
              </v-flex>
              <v-flex class="pl-2" xs6>
                <Multiselect
                  v-model="filter.type"
                  :options="typeOptions"
                  label="text"
                  placeholder="เลือกประเภท"
                  track-by="value"
                  @input="onFilter"
                ></Multiselect>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-data-table
          v-model="selectedUsers"
          :headers="headers"
          :items="filteredUser"
          :loading="loading"
          :pagination.sync="pagination"
          class="elevation-1 scgallrenttable"
          expand
        >
          <!-- select-all -->
          <template #items="props">
            <tr style="cursor: pointer">
              <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                {{ props.item.cartid }}
              </td>
              <template v-if="selectedBot.theme === 'scgdistribution'">
                <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                  {{ props.item.cardnumber }}
                </td>
                <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                  {{ props.item.realname }}
                </td>
                <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                  {{ props.item.address }}
                </td>
              </template>
              <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                {{ props.item.name }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.productname ? props.item.productname : '-' }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.quantity | numberFormat }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.option }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.discountprice }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.discountprice }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.pagename }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.isschedule ? 'รายวัน' : 'Clear ตะกร้า' }}
                {{ props.item.history_timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <div>
      <v-dialog v-model="showCart" persistent width="660">
        <v-card>
          <div class="text-xs-right">
            <v-btn icon small @click="close">
              <v-icon small>close</v-icon>
            </v-btn>
          </div>
          <div>
            <v-layout>
              <v-flex class="text-xs-left my-2 ma-2">
                <span>{{ $t('Total') }}</span>
                <span class="primary--text" style="font-weight: 500">
                  {{ cartitem.total | numberFormat }}
                </span>
              </v-flex>
              <v-flex class="text-xs-right">
                <v-btn color="primary" outline @click="onDeleteSelected">
                  <v-icon class="mr-1">remove_shopping_cart</v-icon>
                  {{ $t('Clear cart') }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="cartheaders"
              :items="cartitem.cartarray"
              :loading="cartloading"
              :pagination.sync="pagination"
              class="elevation-1 scgallrenttable"
              expand
            >
              <template #items="props">
                <tr>
                  <td class="text-xs-center">
                    <v-avatar size="45" tile>
                      <img
                        v-if="props.item.photourl"
                        :alt="props.item.name"
                        :src="props.item.photourl.split(';;')[0]"
                        height="30"
                        width="30"
                        @error="onFailLoad"
                      />
                      <img
                        v-else
                        :alt="props.item.name"
                        :src="'/static/img/assets/livechat/profile.png'"
                        height="30"
                        width="30"
                      />
                    </v-avatar>
                  </td>
                  <td class="text-xs-center">{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.option }}</td>
                  <td class="text-xs-center">{{ props.item.quantity | numberFormat }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter'
import Multiselect from 'vue-multiselect'
import { PAGE_SCG_LIVE } from '../../../../constants/scg_live'

export default {
  components: {
    DateFilter,
    Multiselect
  },
  data() {
    return {
      filterCategoryStatus: 'all',
      selectedDate: {
        start: moment().format('YYYY-MM-DD') + ' 00:00',
        end: moment().format('YYYY-MM-DD') + ' 23:59'
      },
      cartitem: [],
      search: '',
      filterApp: 'all',
      showCart: false,
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },

      cartheaders: [
        {
          text: '',
          value: 'photourl',
          align: 'center',
          width: '3%'
        },
        {
          text: this.$t('name'),
          value: 'name',
          align: 'center',
          width: '3%'
        },
        {
          text: this.$t('option'),
          value: 'option',
          align: 'center',
          width: '1%'
        },
        {
          text: this.$t('Quantity'),
          value: 'quantity',
          align: 'center',
          width: '1%'
        }
        // {
        //   text: this.$t('Price'),
        //   value: 'discountprice',
        //   align: 'center',
        //   width: '2%'
        // }
      ],
      loading: false,
      cartloading: false,
      rawusers: [],
      products: [],
      selectedUsers: [],
      selectedUser: null,
      showsearch: false,
      filter: {
        fullname: '',
        page: '',
        type: '',
        roundStart: '',
        roundEnd: ''
      },
      pageOptions: [
        {
          text: 'All',
          value: ''
        },
        ...PAGE_SCG_LIVE
      ],
      typeOptions: [
        {
          text: 'รายวัน',
          value: true
        },
        {
          text: 'Clear ตะกร้า',
          value: false
        }
      ]
    }
  },
  computed: {
    headers() {
      if (this.selectedBot.theme === 'scgdistribution') {
        return [
          // {
          //   text: '',
          //   value: '',
          //   align: 'center',
          //   width: '3%',
          //   sortable: false,
          // },
          // {
          //   text: '',
          //   value: 'photourl',
          //   align: 'center',
          //   width: '3%',
          //   sortable: false,
          // },

          {
            text: 'Transaction ID',
            value: 'transactionId',
            align: 'center',
            width: '3%',
            sortable: false
          },
          {
            text: this.$t('Shop code'),
            value: 'cardnumber',
            align: 'left',
            width: 'auto'
          },
          {
            text: this.$t('Shop name'),
            value: 'realname',
            align: 'left',
            width: 'auto'
          },
          {
            text: this.$t('Province'),
            value: 'province',
            align: 'left',
            width: 'auto'
          },
          {
            text: this.$t('Name'),
            value: 'name',
            align: 'left',
            width: 'auto'
          },
          {
            text: this.$t('Product name'),
            value: 'productname',
            align: 'center',
            width: '1%'
          },
          {
            text: this.$t('Quantity'),
            value: 'quantity',
            align: 'center',
            width: '1%'
          },
          {
            text: this.$t('Unit'),
            value: 'unit',
            align: 'center',
            width: '1%'
          },
          {
            text: this.$t('Price'),
            value: 'price',
            align: 'center',
            width: '1%'
          },
          {
            text: this.$t('Discount Price'),
            value: 'discountPrice',
            align: 'center',
            width: '1%'
          },

          // {
          //   text: this.$t('Cart price'),
          //   value: 'cartprice',
          //   align: 'center',
          //   width: '1%',
          // },
          {
            text: this.$t('Date') + ' / ' + this.$t('Time'),
            value: 'timestamp',
            align: 'center',
            width: '1%'
          },
          {
            text: 'Facebook Page',
            value: 'facebookPage',
            align: 'center',
            width: '3%'
          },
          {
            text: 'รอบ',
            value: 'round',
            align: 'center',
            width: '3%'
          }
          // {
          //   text: this.$t('Inbox'),
          //   value: 'inboxurl',
          //   align: 'center',
          //   width: '2%',
          // },
        ]
      } else {
        return []
      }
    },
    categories() {
      var uniq = [...new Set(this.rawusers.map((el) => el.categoryname))]
      return uniq
    },
    ...mapGetters(['selectedBot']),
    facebooklength() {
      return this.rawusers.filter((el) => el.app == 'facebook').length
    },
    linelength() {
      return this.rawusers.filter((el) => el.app == 'line').length
    },
    isCentralLive() {
      return this.$store.state.centralPage.includes(this.selectedBot.pageid)
    },
    filteredUser() {
      var result
      var user = this.rawusers
      if (this.search) {
        user = user.filter((val) => val.name.toLowerCase().includes(this.search.toLowerCase()))
      }
      result = user.filter((el) => {
        if (this.filterApp != 'all') {
          return el.app == this.filterApp
        } else {
          return true
        }
      })
      if (this.filterCategoryStatus != 'all') {
        result = result.filter((el) => el.categoryname == this.filterCategoryStatus)
      }
      return result
    }
  },
  mounted() {
    if (
      ['109154847972476', '109181747969457', '178737485661189'].includes(this.selectedBot.pageid)
    ) {
      let currentPage = this.pageOptions.filter((el) => {
        if (el.value == this.selectedBot.pageid) {
          return el
        }
      })
      this.filter.page = currentPage
    }
    this.getUser()
  },
  methods: {
    deleteItem(item) {
      this.$swal
        .fire({
          text: 'ต้องการลบรายการนี้ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            var data = {
              pageid: this.selectedBot.pageid,
              cartid: item.cartid
            }
            console.log(item)
            api.deletecmsviewcartbyid(data, () => {
              this.loading = false
              this.getUser()
            })
          }
        })
    },
    onSearch() {
      this.showsearch = false
      this.getUser()
    },
    clearsearch() {
      this.filter = {
        fullname: '',
        page: '',
        type: '',
        round: ''
      }
      this.showsearch = false
      this.onSearch()
    },
    onEditAddress(type, payload, item) {
      var vm = this
      vm.$store.dispatch('loading')

      var data = {
        pageid: this.selectedBot.pageid,
        usersid: payload.usersid,
        address: payload.customer_value
      }
      api.saveUserAddress(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }

        vm.$store.dispatch('loading')
        this.$set(item, type, payload.customer_value)
      })
    },
    putuserrealname(type, payload, item) {
      var vm = this

      this.$set(item, type, payload.customer_value)

      vm.$store.dispatch('loading')
      var data = {
        body: {
          usersid: item.id,
          realname: payload.customer_value
        },
        params: {
          pageid: this.selectedBot.pageid
        }
      }
      api.putuserrealname(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.getUser()
        vm.$forceUpdate()
      })
    },
    putusercardnumber(type, payload, item) {
      var vm = this
      this.$set(item, type, payload.customer_value)

      vm.$store.dispatch('loading')
      var data = {
        body: {
          usersid: item.id,
          cardnumber: payload.customer_value
        },
        params: {
          pageid: this.selectedBot.pageid
        }
      }
      api.putusercardnumber(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.getUser()
        vm.$forceUpdate()
      })
    },
    async onDeleteSelected() {
      if (this.selectedUser) {
        this.selectedUsers.push(this.selectedUser)
        await this.onDeleteAllInCart()
        this.showCart = false
      }
    },
    async onDeleteAllInCart() {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to clear cart'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        var userid = this.selectedUsers.map((el) => {
          return el.id
        })
        this.loading = true
        await this.deleteAllInCart(userid)
        this.rawusers = this.rawusers.filter((el) => !userid.includes(el.id))

        this.loading = false
      }
    },
    deleteAllInCart(userid) {
      return new Promise((resolve, reject) => {
        if (!this.selectedUsers || this.selectedUsers.length == 0) {
          reject()
        }
        var data = {
          pageid: this.selectedBot.pageid,
          userid_arr: userid
        }
        api.deleteAllInCart(data, (error, response) => {
          if (error) {
            console.error(error)
          }
          resolve(response)
        })
      })
    },
    onDateChanged() {
      // this.filter.fullname = ''
      this.getUser()
    },
    close() {
      this.cartitem = []
      this.showCart = false
    },
    viewInbox(link) {
      window.open(link, '_blank')
    },
    showCartDialog(id) {
      this.showCart = id

      var user = this.rawusers.find((el) => {
        return el.id == id
      })
      this.selectedUser = user
      this.getCart(id)
    },
    getCart(id) {
      this.cartloading = true
      api.getusercart({ pageid: this.selectedBot.pageid, userid: id }, (err, response) => {
        this.cartloading = false
        if (response && response.cartarray) {
          this.cartitem = response
        }
      })
    },
    onFailLoad: function (e) {
      // console.log(e)
      e.target.src = '/static/img/assets/livechat/profile.png'
      // this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getUser() {
      this.loading = true

      var pageid = ''
      if (
        ['109154847972476', '109181747969457', '178737485661189'].includes(this.selectedBot.pageid)
      ) {
        pageid = ''
        if (this.filter.page) {
          pageid = this.filter.page.value
        } else {
          pageid = this.selectedBot.pageid
        }
      } else {
        pageid = this.selectedBot.pageid
      }

      var data = {
        pageid: pageid,
        startdate_history: this.selectedDate.start,
        enddate_history: this.selectedDate.end
      }

      if (this.filter.type) {
        Object.assign(data, {
          isschedule: this.filter.type.value
        })
      }
      // if (this.filter.roundStart) {
      //   Object.assign(data, {
      //     startdate_history: this.filter.roundStart,
      //   })
      // }
      // if (this.filter.roundEnd) {
      //   Object.assign(data, {
      //     enddate_history: this.filter.roundEnd,
      //   })
      // }

      api.getcmsviewcartshistory(data, (err, response) => {
        this.loading = false
        if (response.data) {
          this.rawusers = response.data
        } else {
          this.rawusers = []
        }
      })
    },
    exportCartSummary: function () {
      let vm = this
      if (vm.loading) {
        return false
      }
      var csvdata =
        'Shop code,Shop name,Province,Name,Product name,Quantity,Unit,Price,Discount price,Date&Time\r\n'

      this.filteredUser.forEach((el) => {
        csvdata += `${el.cardnumber ? el.cardnumber : '-'},${el.realname ? el.realname : '-'},${
          el.address ? el.address.replaceAll(',', '') : '-'
        },${el.name ? el.name : '-'},${el.productname ? vm.escapeCsvValue(el.productname) : '-'},${
          el.quantity ? el.quantity : '-'
        },${el.option ? el.option : '-'},${el.price ? el.price : '-'},${
          el.discountprice ? el.discountprice : '-'
        },${el.timestamp ? moment(el.timestamp).format('DD/MM/YYYY HH:mm') : '-'}\r\n`
      })
      vm.exportCsv(csvdata, 'cartsummary')
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    onFilter() {
      this.getUser()
    },
    clearDateTime(item) {
      if (item == 'roundStart') {
        this.filter.roundStart = ''
      }
      if (item == 'roundEnd') {
        this.filter.roundEnd = ''
      }

      this.getUser()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/CartReportScgdistribute.vue